<template>
    <div class="styleguide">
        <div class="row">
            <div class="col-12">
                <h1>Styled elements according to Minimax Design</h1>
            </div>
        </div>
        <div class="row">
            <div class="col-12">
                <div class="styleguide__component_block">
                    <div class="styleguide__component_header">
                        <h6>Buttons</h6>
                    </div>
                    <div class="styleguide__component_content">
                        <a href="#" class="button">Button</a>
                        <a href="#" class="button is-loading">Loading Button</a>
                        <a href="#" class="button is-disabled">Button Disabled</a>
                        <a href="#" class="button--cta">Button CTA</a>
                        <a href="#" class="button--cta is-disabled" disabled>Button CTA Disabled</a>
                        <br/>
                        <a href="#" class="button--link">Button Link</a>
                        <br/>
                        <a href="#" class="button--icon">Button with icon <i class="mdi mdi-pencil"></i></a>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="styleguide__component_block">
                    <div class="styleguide__component_header">
                        <h6>Teksten</h6>
                    </div>
                    <div class="styleguide__component_content">
                        <h1>This is an H1 text</h1>
                        <h2>This is an H2 text</h2>
                        <h3>This is an H3 text</h3>
                        <p>This is a short text to present what some standard, <strong>bold</strong> and <i>italic</i> text and <a href="#">a link</a> would look like.</p>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="styleguide__component_block">
                    <div class="styleguide__component_header">
                        <h6>Spinner</h6>
                    </div>
                    <div class="styleguide__component_content">
                        <div class="styleguide__item">
                            <div class="spinner"></div>
                        </div>
                        <div class="styleguide__item">
                            <div class="spinner--small"></div>
                        </div>
                        <div class="styleguide__item">
                            <loader :loading="spinner">
                                Hello world (big spinner)
                            </loader>
                        </div>
                        <div class="styleguide__item">
                            <loader :loading="spinner" :small="true">
                                Hello world (small spinner)
                            </loader>
                        </div>
                        <div class="styleguide__item">
                            <button class="button--cta" @click="spinner = !spinner">Toggle spinner</button>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="styleguide__component_block">
                    <div class="styleguide__component_header">
                        <h6>Breadcrumb</h6>
                    </div>
                    <div class="styleguide__component_content">
                        <ul class="breadcrumb">
                            <li><a href="#">Home</a></li>
                            <li><a href="#">Category</a></li>
                            <li>Security Design Tool</li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="styleguide__component_block">
                    <div class="styleguide__component_header">
                        <h6>Forms</h6>
                    </div>
                    <div class="styleguide__component_content">
                        <form class="form">
                            <div class="row">
                                <div class="col-12 col-sm-8 col-md-6">
                                    <div class="form__group">
                                        <label class="form__label">These are your options:</label>
                                        <div class="checkbox is-inline">
                                            <input class="checkbox__cb" type="checkbox" id="cb"/>
                                            <label class="checkbox__label" for="cb">Optie 1</label>
                                        </div>
                                        <div class="checkbox is-inline">
                                            <input class="checkbox__cb" type="checkbox" id="cb_2"/>
                                            <label class="checkbox__label" for="cb_2">Optie 2</label>
                                        </div>
                                    </div>
                                    <div class="form__group">
                                        <label class="form__label">Choose an option:</label>
                                        <div class="radio is-inline">
                                            <input class="radio__rb" type="radio" name="radio" id="radio"/>
                                            <label class="radio__label" for="radio">Radio button 1</label>
                                        </div>
                                        <div class="radio is-inline">
                                            <input class="radio__rb" type="radio" name="radio" id="radio_1"/>
                                            <label class="radio__label" for="radio_1">Radio button 2</label>
                                        </div>
                                    </div>

                                    <div class="form__group">
                                        <label class="form__label">Text field without icon</label>
                                        <input class="form__input--text" type="text" placeholder="This is an input field"/>
                                    </div>

                                    <div class="form__group">
                                        <label class="form__label">Text field with icon</label>
                                        <i class="form__input__icon mdi mdi-email-outline"></i>
                                        <input class="form__input--text has-icon" type="text" placeholder="Type email here"/>
                                    </div>

                                    <div class="form__group">
                                        <label class="form__label">Text field with an error</label>
                                        <input class="form__input--text has-error" type="text" placeholder="Dit is an input field with an error" value="test"/>
                                    </div>

                                    <div class="form__group">
                                        <label class="form__label">Textarea</label>
                                        <textarea class="form__input--textarea" placeholder="Start typing here..."></textarea>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="styleguide__component_block">
                    <div class="styleguide__component_header">
                        <h6>Table</h6>
                    </div>
                    <div class="styleguide__component_content">
                        <div class="styleguide__item">
                            <div class="table__responsive">
                                <table class="table">
                                    <thead>
                                    <tr>
                                        <th>Email</th>
                                        <th class="table__wrap">Data</th>
                                        <th>State</th>
                                        <th></th>
                                    </tr>
                                    </thead>
                                    <tbody>
                                    <tr>
                                        <td>test@elnino.tech</td>
                                        <td>Wed. 10-10-2018</td>
                                        <td class="success"><i class="mdi mdi-check"></i>Bought</td>
                                        <td class="success">You got the 50 euro discount!</td>
                                    </tr>
                                    <tr>
                                        <td>test@elnino.tech</td>
                                        <td>Wed. 10-10-2018</td>
                                        <td><i class="mdi mdi-email-outline"></i>Email received</td>
                                        <td></td>
                                    </tr>
                                    <tr>
                                        <td>test@elnino.tech</td>
                                        <td>Wed. 10-10-2018</td>
                                        <td><i class="mdi mdi-sync"></i>In progress</td>
                                        <td></td>
                                    </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <h1>Elements to be styled</h1>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="styleguide__component_block">
                    <div class="styleguide__component_header">
                        <h6>Dropdowns</h6>
                    </div>
                    <div class="styleguide__component_content">
                        <form class="form">
                            <div class="row">
                                <div class="col-12 col-sm-8 col-md-6">
                                    <div class="form__group">
                                        <label class="form__label">This is a dropdown</label>
                                        <v-select v-model="selected" :options="['Dropdown Item 1','Dropdown Item 2','Dropdown Item 3']" value="Item 1" placeholder="Choose an item..."></v-select>
                                    </div>
                                    <div class="form__group">
                                        <label class="form__label">This is a multiple select dropdown</label>
                                        <v-select multiple class="dropdown" :options="['First item','Second item','Third item']"  placeholder="Choose an item..."></v-select>
                                    </div>
                                </div>
                            </div>
                        </form>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="styleguide__component_block">
                    <div class="styleguide__component_header">
                        <h6>Search</h6>
                    </div>
                    <div class="styleguide__component_content">
                        <div class="styleguide__item">
                            <form class="search">
                                <input class="search__input" type="search" placeholder="Search.." />
                                <button class="search__button button--cta" type="submit">Search</button>
                            </form>
                        </div>
                        <div class="styleguide__item">
                            <form class="search">
                                <input class="search__input" type="search" placeholder="Search.." />
                                <button class="search__button button" type="submit">Search</button>
                            </form>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="styleguide__component_block">
                    <div class="styleguide__component_header">
                        <h6>Alerts</h6>
                    </div>
                    <div class="styleguide__component_content">
                        <div class="row">
                            <div class="col-12 col-md-8 col-lg-6">
                                <div class="styleguide__item">
                                    <div class="alert">This is a normal information alert!</div>
                                </div>
                                <div class="styleguide__item">
                                    <div class="alert--success">This is a success alert!</div>
                                </div>
                                <div class="styleguide__item">
                                    <div class="alert--warning">This is a warning alert</div>
                                </div>
                                <div class="styleguide__item">
                                    <div class="alert--error">This is an error alert</div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="styleguide__component_block">
                    <div class="styleguide__component_header">
                        <h6>Pagination</h6>
                    </div>
                    <div class="styleguide__component_content">
                        <ul class="pagination">
                            <li class="active"><a href="#">1</a></li>
                            <li><a href="#">2</a></li>
                            <li><a href="#">3</a></li>
                        </ul>
                    </div>
                </div>
            </div>
        </div>


        <div class="row">
            <div class="col-12">
                <div class="styleguide__component_block">
                    <div class="styleguide__component_header">
                        <h6>Modal</h6>
                    </div>
                    <div class="styleguide__component_content">
                        <button class="button--cta" @click="showStyleguideModal">Open modal</button>
                        <button class="button--cta" @click="showStyleguideModalSmall">Open small modal</button>

                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <div class="col-12">
                <div class="styleguide__component_block">
                    <div class="styleguide__component_header">
                        <h6>Tooltips</h6>
                    </div>
                    <div class="styleguide__component_content">
                        <div class="row">
                            <div class="col-6">
                                <span :data-tooltip="`You've been on this page ${tooltip} seconds`" data-tooltip-pos="up"><i class="mdi mdi-cursor-pointer"></i> Reactive tooltip</span><br />
                                <span data-tooltip="This tooltip is positioned at the top!" data-tooltip-pos="up"><i class="mdi mdi-cursor-pointer"></i> Top tooltip</span><br />
                                <span data-tooltip="This one's on right!" data-tooltip-pos="right"><i class="mdi mdi-cursor-pointer"></i> Right tooltip</span><br />
                                <span data-tooltip="And on left!" data-tooltip-pos="left"><i class="mdi mdi-cursor-pointer"></i> Left tooltip</span><br />
                                <span data-tooltip="This tooltip is positioned at the bottom!" data-tooltip-pos="down"><i class="mdi mdi-cursor-pointer"></i> Bottom tooltip</span>
                            </div>
                            <div class="col-6">
                                <span data-tooltip="NL/EN" data-tooltip-length="small" data-tooltip-pos="up"><i class="mdi mdi-cursor-pointer"></i> Small tooltip</span><br />
                                <span data-tooltip="Now that's a super big text we have over here right? Lorem ipsum dolor sit I'm done." data-tooltip-length="medium" data-tooltip-pos="up"><i class="mdi mdi-cursor-pointer"></i> Medium tooltip</span><br />
                                <span data-tooltip="What about something really big? This may surpass your window dimensions. Imagine you're on that boring class with that boring teacher and you didn't slept so well last night. Suddenly you're sleeping in class. Can you believe it?!" data-tooltip-length="large" data-tooltip-pos="up"><i class="mdi mdi-cursor-pointer"></i> Large tooltip</span><br />
                                <span data-tooltip="What about something really big? This may surpass your window dimensions. Imagine you're on that boring class with that boring teacher and you didn't slept so well last night. Suddenly you're sleeping in class. Can you believe it?!" data-tooltip-length="xlarge" data-tooltip-pos="up"><i class="mdi mdi-cursor-pointer"></i> Extra large tooltip</span><br />
                                <span data-tooltip-visible data-tooltip="I'll stick around 😉" data-tooltip-pos="right"><i class="mdi mdi-cursor-pointer"></i> Always visible tooltip</span><br />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <styleguide-modal></styleguide-modal>
        <styleguide-modal-small></styleguide-modal-small>
    </div>
</template>

<script>
    import Vue from 'vue';
    import { Component } from 'vue-property-decorator';
    import vSelect from 'vue-select';

    import StyleguideModal from '@/components/modals/StyleguideModal';
    import StyleguideModalSmall from '@/components/modals/StyleguideModalSmall';
    import Loader from '../components/general/Loader';

    @Component({
        data: () => {
            return {
                tooltip: 0,
                spinner: false,
            };
        },
        mounted() {
            setInterval(() => {
                this.tooltip += 1;
            }, 1000);
        },
        components: {
            Loader,
            vSelect,
            StyleguideModal,
            StyleguideModalSmall
        }
    })
    export default class Styleguide extends Vue {
        name = 'styleguide';
        selected = null;

        showStyleguideModal () {
            this.$modal.show('styleguide-modal');
        }

        showStyleguideModalSmall () {
            this.$modal.show('styleguide-modal-small');
        }
    }
</script>



// WEBPACK FOOTER //
// src/pages/Styleguide.vue